var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"audit-status",class:'status-' + _vm.status.toLowerCase()},[_vm._v(" "+_vm._s(_vm.label)+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }